import React from "react";
import {
  t,
  MI_ITIN,
  MI_FINANCIAL_PERFORMANCE,
  MI_MANAGEMENT,
  MI_RTI_ACT,
  MI_AWARDS,
  MI_GST,
  MI_KNOW_MORE,
  MI_SAKALA_SERVICES,
  MI_STUDENT_PASS,
  MI_WBFP,
  MI_SUTP_ITS,
  MI_MORTH_PROJECT,
  MI_MORTH_VTMS_PIS,
  MI_PROJECT,
  MI_HIRE_BUS,
  MI_CASULA_CONTACT,
  MI_NEW_FRANCHISEE,
  MI_GENERAL_INFO,
} from "../../translations/AboutUs/MenuList";

import {
  tFooterCommon,
  ABOUT_US,
  HISTORY,
  MI_BUS_SERVICES,
  MI_KEY_STATISTICS,
  MI_LABOUR_WELFARE,
  MI_PROCUREMENT,
  MI_PASSENGER_SAFETY,
  MI_INFRA_FACILITY,
  MI_ANNUAL_REPORT,
  MI_LETTER_CIRCULARS,
  MI_LUGGAGE_RATES,
  MI_RES_TERMS,
  MI_GUEST_USER_TERMS,
  MI_REFUND_RULES,
  MI_BOOKING_COUNTERS,
  MI_PASSESS_CONCESSION,
  MI_NEWS_EVENTS,
  MI_TENDER,
  MI_RECRUITMENT,
  MI_CAREERS,
  MI_SENIORITY_LIST,
  MI_KSRTC_FRANCHISEE,
} from "../../translations/Footer/Common";

const MenuList = (props) => {
  const { currentPage, currentMenu, handelCurrentPage } = props;
  return (
    <div className="side_menu_luggage">
      {/* <div className="item_luggage">
        <div
          className={`${
            currentMenu == "aboutus"
              ? "menu-heading-luggage"
              : "menu-heading-non-luggage"
          }`}
        >
          <input type="radio" name="" id="" className="radio_style" />
          <span className="menu-list-heading-luggage">
            {" "}
            {tFooterCommon(ABOUT_US)}
          </span>
        </div>
        <div className="item-list-luggage">
          <ul style={{ listStyleType: "none" }}>
            <li
              className={`${currentPage == "history" ? "activeMenu" : ""}`}
              onClick={() => handelCurrentPage("aboutus", "history")}
            >
              {tFooterCommon(HISTORY)}
            </li>
            <li
              className={`${
                currentPage == "key-statistics" ? "activeMenu" : ""
              }`}
              onClick={() => handelCurrentPage("aboutus", "key-statistics")}
            >
              {tFooterCommon(MI_KEY_STATISTICS)}
            </li>
            <li
              className={`${
                currentPage == "infrastructure-facility" ? "activeMenu" : ""
              }`}
              onClick={() =>
                handelCurrentPage("aboutus", "infrastructure-facility")
              }
            >
              {tFooterCommon(MI_INFRA_FACILITY)}
            </li>
            <li
              className={`${
                currentPage == "annual-administration-report"
                  ? "activeMenu"
                  : ""
              }`}
              onClick={() =>
                handelCurrentPage("aboutus", "annual-administration-report")
              }
            >
              {tFooterCommon(MI_ANNUAL_REPORT)}
            </li>
            <li
              className={`${currentPage == "it-in-ksrtc" ? "activeMenu" : ""}`}
              onClick={() => handelCurrentPage("aboutus", "it-in-ksrtc")}
            >
              {t(MI_ITIN)}
            </li>
            <li
              className={`${
                currentPage == "financial-performance" ? "activeMenu" : ""
              }`}
              onClick={() =>
                handelCurrentPage("aboutus", "financial-performance")
              }
            >
              {t(MI_FINANCIAL_PERFORMANCE)}
            </li>
            <li
              className={`${currentPage == "bus-services" ? "activeMenu" : ""}`}
              onClick={() => handelCurrentPage("aboutus", "bus-services")}
            >
              {tFooterCommon(MI_BUS_SERVICES)}
            </li>
            <li
              className={`${
                currentPage == "labour-welfare" ? "activeMenu" : ""
              }`}
              onClick={() => handelCurrentPage("aboutus", "labour-welfare")}
            >
              {tFooterCommon(MI_LABOUR_WELFARE)}
            </li>
            <li
              className={` ${currentPage == "procurement" ? "activeMenu" : ""}`}
              onClick={() => handelCurrentPage("aboutus", "procurement")}
            >
              {tFooterCommon(MI_PROCUREMENT)}
            </li>
            <li
              className={` ${
                currentPage == "passenger-safety" ? "activeMenu" : ""
              }`}
              onClick={() => handelCurrentPage("aboutus", "passenger-safety")}
            >
              {tFooterCommon(MI_PASSENGER_SAFETY)}
            </li>
            <li
              className={` ${currentPage == "management" ? "activeMenu" : ""}`}
              onClick={() => handelCurrentPage("aboutus", "management")}
            >
              {t(MI_MANAGEMENT)}
            </li>
            <li
              className={`menu-item ${
                currentPage == "rti-act" ? "activeMenu" : ""
              }`}
              onClick={() => handelCurrentPage("aboutus", "rti-act")}
            >
              {t(MI_RTI_ACT)}
            </li>
            <li
              className={` ${currentPage == "awards" ? "activeMenu" : ""}`}
              onClick={() => handelCurrentPage("aboutus", "awards")}
            >
              {t(MI_AWARDS)}
            </li>
            <li
              className={`menu-item ${
                currentPage == "gst" ? "activeMenu" : ""
              }`}
              onClick={() => handelCurrentPage("aboutus", "gst")}
            >
              {t(MI_GST)}
            </li>
          </ul>
        </div>
      </div> */}

      <div className="item_luggage">
        <div
          className={`${
            currentMenu == "know-more-about"
              ? "menu-heading-luggage"
              : "menu-heading-non-luggage"
          }`}
        >
          <input type="radio" name="" id="" className="radio_style" />
          <span className="menu-list-heading-luggage">{t(MI_KNOW_MORE)}</span>
        </div>
        <div className="item-list-luggage">
          <ul style={{ listStyleType: "none" }}>
            {/* <li
              className={`${
                currentPage == "letters-circulars" ? "activeMenu" : ""
              }`}
              onClick={() =>
                handelCurrentPage("know-more-about", "letters-circulars")
              }
            >
              {tFooterCommon(MI_LETTER_CIRCULARS)}
            </li>
            <li
              className={`${
                currentPage == "luggage-rates" ? "activeMenu" : ""
              }`}
              onClick={() =>
                handelCurrentPage("know-more-about", "luggage-rates")
              }
            >
              {tFooterCommon(MI_LUGGAGE_RATES)}
            </li> */}
            <li
              className={`${
                currentPage == "reservation-terms" ? "activeMenu" : ""
              }`}
              onClick={() =>
                handelCurrentPage("know-more-about", "reservation-terms")
              }
            >
              {tFooterCommon(MI_RES_TERMS)}
            </li>
            <li
              className={`${
                currentPage == "guest-users-terms" ? "activeMenu" : ""
              }`}
              onClick={() =>
                handelCurrentPage("know-more-about", "guest-users-terms")
              }
            >
              {tFooterCommon(MI_GUEST_USER_TERMS)}
            </li>
            <li
              className={`${
                currentPage == "refund-rules-and-claims" ? "activeMenu" : ""
              }`}
              onClick={() =>
                handelCurrentPage("know-more-about", "refund-rules-and-claims")
              }
            >
              {tFooterCommon(MI_REFUND_RULES)}
            </li>
            <li
              className={`${
                currentPage == "booking-counters" ? "activeMenu" : ""
              }`}
              onClick={() =>
                handelCurrentPage("know-more-about", "booking-counters")
              }
            >
              {tFooterCommon(MI_BOOKING_COUNTERS)}
            </li>
            {/* <li
              className={`${
                currentPage == "passes-n-concession" ? "activeMenu" : ""
              }`}
              onClick={() =>
                handelCurrentPage("know-more-about", "passes-n-concession")
              }
            >
              {tFooterCommon(MI_PASSESS_CONCESSION)}
            </li>
            <li
              className={`${
                currentPage == "sakala-services" ? "activeMenu" : ""
              }`}
              onClick={() =>
                handelCurrentPage("know-more-about", "sakala-services")
              }
            >
              {t(MI_SAKALA_SERVICES)}
            </li>
            <li
              className={`${currentPage == "student-pass" ? "activeMenu" : ""}`}
              onClick={() =>
                handelCurrentPage("know-more-about", "student-pass")
              }
            >
              {t(MI_STUDENT_PASS)}
            </li> */}
          </ul>
        </div>
      </div>

      {/* <div className="item_luggage">
        <div
          className={`${
            currentMenu == "world-bank-funded-project"
              ? "menu-heading-luggage"
              : "menu-heading-non-luggage"
          }`}
        >
          <input type="radio" name="" id="" className="radio_style" />
          <span className="menu-list-heading-luggage">{t(MI_WBFP)}</span>
        </div>
        <div className="item-list-luggage">
          <ul>
            <li
              className={`${currentPage == "sutp-its" ? "activeMenu" : ""}`}
              onClick={() =>
                handelCurrentPage("world-bank-funded-project", "sutp-its")
              }
            >
              {t(MI_SUTP_ITS)}
            </li>
          </ul>
        </div>
      </div> 

      <div className="item_luggage">
        <div
          className={`${
            currentMenu == "morth-assisted-project"
              ? "menu-heading-luggage"
              : "menu-heading-non-luggage"
          }`}
        >
          <input type="radio" name="" id="" className="radio_style" />
          <span className="menu-list-heading-luggage">
            {t(MI_MORTH_PROJECT)}
          </span>
        </div>
        <div className="item-list-luggage">
          <ul>
            <li
              className={`${
                currentPage == "morth-project" ? "activeMenu" : ""
              }`}
              onClick={() =>
                handelCurrentPage("morth-assisted-project", "morth-project")
              }
            >
              {t(MI_MORTH_VTMS_PIS)}
              <br />
              {t(MI_PROJECT)}
            </li>
          </ul>
        </div>
      </div>

      <div className="item_luggage">
        <div
          className={`${
            currentMenu == "hireabus"
              ? "menu-heading-luggage"
              : "menu-heading-non-luggage"
          }`}
        >
          <input type="radio" name="" id="" className="radio_style" />
          <span className="menu-list-heading-luggage">{t(MI_HIRE_BUS)}</span>
        </div>
        <div className="item-list-luggage">
          <ul>
            <li
              className={`${
                currentPage == "casual-contact" ? "activeMenu" : ""
              }`}
              onClick={() => handelCurrentPage("hireabus", "casual-contact")}
            >
              {t(MI_CASULA_CONTACT)}
            </li>
          </ul>
        </div>
      </div>*/}

      <div className="item_luggage">
        <div
          className={`${
            currentMenu == "franchisee"
              ? "menu-heading-luggage"
              : "menu-heading-non-luggage"
          }`}
        >
          <input type="radio" name="" id="" className="radio_style" />
          <span className="menu-list-heading-luggage">
            {tFooterCommon(MI_KSRTC_FRANCHISEE)}
          </span>
        </div>
        <div className="item-list-luggage">
          <ul>
            <li
              className={`${
                currentPage == "new-franchisee" ? "activeMenu" : ""
              }`}
              onClick={() => handelCurrentPage("franchisee", "new-franchisee")}
            >
              {t(MI_NEW_FRANCHISEE)}
            </li>
          </ul>
        </div>
      </div>

      {/* <div className="item_luggage">
        <div
          className={`${
            currentMenu == "general-information"
              ? "menu-heading-luggage"
              : "menu-heading-non-luggage"
          }`}
        >
          <input type="radio" name="" id="" className="radio_style" />
          <span className="menu-list-heading-luggage">
            {t(MI_GENERAL_INFO)}
          </span>
        </div>
        <div className="item-list-luggage">
          <ul>
            <li
              className={`${
                currentPage == "news-and-events" ? "activeMenu" : ""
              }`}
              onClick={() =>
                handelCurrentPage("general-information", "news-and-events")
              }
            >
              {tFooterCommon(MI_NEWS_EVENTS)}
            </li>
            <li
              className={`${currentPage == "tender" ? "activeMenu" : ""}`}
              onClick={() => handelCurrentPage("general-information", "tender")}
            >
              {tFooterCommon(MI_TENDER)}
            </li>
            <li
              className={`${currentPage == "recruitment" ? "activeMenu" : ""}`}
              onClick={() =>
                handelCurrentPage("general-information", "recruitment")
              }
            >
              {tFooterCommon(MI_RECRUITMENT)}
            </li>
            <li
              className={`${currentPage == "careers" ? "activeMenu" : ""}`}
              onClick={() =>
                handelCurrentPage("general-information", "careers")
              }
            >
              {tFooterCommon(MI_CAREERS)}
            </li>
            <li
              className={`${
                currentPage == "senioritylist" ? "activeMenu" : ""
              }`}
              onClick={() =>
                handelCurrentPage("general-information", "senioritylist")
              }
            >
              {tFooterCommon(MI_SENIORITY_LIST)}
            </li>
          </ul>
        </div>
      </div> */}
    </div>
  );
};

export default MenuList;
